// Version : 0.0.1
// Author : SABARI

import { all, call, put, takeLatest } from 'redux-saga/effects';
import { encryptData } from '../../_common/enode-decode';
import AlertManager from '../../../utils/alertManager';
import TransferBranchTypes from './transfer-branch.types';
import {
	createDuplicateCenterGroupFailure,
	createDuplicateCenterGroupResponseChanged,
	createDuplicateCenterGroupSuccess,
	addBranchToCenterFailure,
	addBranchToCenterResponseChanged,
	addBranchToCenterSuccess,
	transferMemberListFailure,
	transferMemberListSuccess,
	transferMemberListResponseChanged,
	fetchTransferCenterListFailure,
	fetchTransferCenterListSuccess,
	fetchTransferCenterListResponseChanged,
} from './transfer-branch.action';
import {
	createDuplicateCenterGroupDetail,
	memberBranchToCenterTransfer,
	transferCenterFetch,
	transferMemberList,
} from './transfer-branch.service';

/************** CREATE DUPLICATE CENTER GROUP START ******************/
export function* createDuplicateCenterGroupData({ payload }: any) {
	try {
		const key = 'AddDuplicateCenterKey';
		const {
			companyID,
			databaseName,
			oldCenterID,
			oldBranchID,
			transferredBranchID,
			userID,
			userName,
		} = payload;
		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
			OldCenterID: oldCenterID,
			OldBranchID: oldBranchID,
			TransferredBranchID: transferredBranchID,
			UserID: userID,
			UserName: userName,
		};

		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(createDuplicateCenterGroupDetail, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(createDuplicateCenterGroupFailure(responseData.data));
		} else {
			yield put(createDuplicateCenterGroupSuccess(responseData.data));
		}
	} catch (error) {
		yield put(createDuplicateCenterGroupFailure(error));
	}
}

export function* resetCreateDuplicateCenterGroupDetailsResponse() {
	yield put(createDuplicateCenterGroupResponseChanged());
}

export function* onCreateDuplicateCenterGroupDetails() {
	yield takeLatest(
		TransferBranchTypes.CREATE_DUPLICATE_CENTER_GROUP_START,
		createDuplicateCenterGroupData,
	);
}

export function* onCreateDuplicateCenterGroupDetailsResponseReset() {
	yield takeLatest(
		TransferBranchTypes.CREATE_DUPLICATE_CENTER_GROUP_RESPONSE_RESET_START,
		resetCreateDuplicateCenterGroupDetailsResponse,
	);
}
/************** CREATE DUPLICATE CENTER GROUP END ******************/

/************** MEMBER BRANCH TO CENTER TRANSAFER START ******************/
export function* memberBranchToCenterTransferData({ payload }: any) {
	try {
		const {
			loanIndexArr,
			memList,
			fromBranchID,
			fromCenterID,
			fromGroupID,
			funderID,
			groupOfficerID,
			precloseDate,
			toCenterID,
			toBranchID,
			toGroupID,
			transferBranchUniqueID,
			transaferCenterUniqueID,
			transferByUserID,
			transferID,
			transferLogType,
			transferType,
			uniqueTransferID,
			userID,
			isMemberWiseFunder,
			isTransferWithInterest,
			companyID,
			databaseName,
			dulicateSameGroupAndMapSameOfficer,
			lastLoanIndexUID,
			investorName,
			iSThrift,
		} = payload;
		const key = 'AddTransferBranchCenterKey';
		const jsonData = {
			LoanIndexArr: loanIndexArr,
			MemList: memList,
			FromBranchID: fromBranchID,
			FromCenterID: fromCenterID,
			FromGroupID: fromGroupID,
			InvestorID: funderID,
			GroupOfficerID: groupOfficerID,
			PrecloseDate: precloseDate,
			ToCenterID: toCenterID,
			ToBranchID: toBranchID,
			ToGroupID: toGroupID,
			TransferBranchUniqueID: transferBranchUniqueID,
			TransferByUserID: transferByUserID,
			TransferLogID: transferID,
			TransferLogType: transferLogType,
			TransferType: transferType,
			UniqueTransferID: uniqueTransferID,
			UserID: userID,
			isMemberWiseFunder,
			isTransferWithInterest,
			CompanyID: companyID,
			DatabaseName: databaseName,
			DulicateSameGroupAndMapSameOfficer: dulicateSameGroupAndMapSameOfficer,
			TransferCenterUniqueID: transaferCenterUniqueID,
			LastLoanIndexUID: lastLoanIndexUID,
			InvestorName: investorName,
			ISThrift: iSThrift,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(memberBranchToCenterTransfer, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(addBranchToCenterFailure(responseData.data));
		} else {
			yield put(addBranchToCenterSuccess(responseData.data));
		}
	} catch (error) {
		yield put(addBranchToCenterFailure(error));
	}
}

export function* resetAddBranchToCenterTransfer() {
	yield put(addBranchToCenterResponseChanged());
}

export function* onBranchToCenterDetail() {
	yield takeLatest(
		TransferBranchTypes.MEMBER_BRANCH_TO_CENTER_TRANSAFER_START,
		memberBranchToCenterTransferData,
	);
}

export function* onAddBranchToCenterResponseReset() {
	yield takeLatest(
		TransferBranchTypes.MEMBER_BRANCH_TO_CENTER_TRANSAFER_RESPONSE_RESET_START,
		resetAddBranchToCenterTransfer,
	);
}
/************** CREATE DUPLICATE CENTER GROUP END ******************/

/************** TRANSFER MEMBER LIST START ******************/
export function* transferMemberListData({ payload }: any) {
	try {
		const key = 'GetMemberListKey';
		const { companyID, databaseName, transferID } = payload;
		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
			TransferID: transferID,
		};

		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(transferMemberList, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(transferMemberListFailure(responseData.data));
		} else {
			yield put(transferMemberListSuccess(responseData.data));
		}
	} catch (error) {
		yield put(transferMemberListFailure(error));
	}
}

export function* resetTransferMemberListResponse() {
	yield put(transferMemberListResponseChanged());
}

export function* onTransferMemberListStart() {
	yield takeLatest(TransferBranchTypes.TRANSFER_MEMBER_LIST_START, transferMemberListData);
}

export function* onTransferMemberListResponseReset() {
	yield takeLatest(
		TransferBranchTypes.TRANSFER_MEMBER_LIST_RESPONSE_RESET_START,
		resetTransferMemberListResponse,
	);
}
/************** TRANSFER MEMBER LIST END ******************/

/************** FETCH TRANSFER CENTER LIST START ******************/
export function* fetchTransferCenterListData({ payload }: any) {
	try {
		const key = 'GetAllCentersList';
		const { companyID, branchID, userLevel, databaseName } = payload;
		const jsonData = {
			CompanyID: companyID,
			BranchID: branchID,
			Level: userLevel,
			DatabaseName: databaseName,
		};

		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(transferCenterFetch, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchTransferCenterListFailure(responseData.data));
		} else {
			yield put(fetchTransferCenterListSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchTransferCenterListFailure(error));
	}
}

export function* resetTransferCenterListResponse() {
	yield put(fetchTransferCenterListResponseChanged());
}

export function* onFetchTransferCenterListStart() {
	yield takeLatest(
		TransferBranchTypes.FETCH_TRANSFER_CENTER_LIST_START,
		fetchTransferCenterListData,
	);
}

export function* onFetchTransferCenterListResponseReset() {
	yield takeLatest(
		TransferBranchTypes.FETCH_TRANSFER_CENTER_LIST_RESPONSE_RESET_START,
		resetTransferCenterListResponse,
	);
}
/************** FETCH TRANSFER CENTER LIST END ******************/

export function* transferBranchSaga() {
	yield all([
		call(onCreateDuplicateCenterGroupDetails),
		call(onCreateDuplicateCenterGroupDetailsResponseReset),
		call(onBranchToCenterDetail),
		call(onAddBranchToCenterResponseReset),
		call(onTransferMemberListStart),
		call(onTransferMemberListResponseReset),
		call(onFetchTransferCenterListStart),
		call(onFetchTransferCenterListResponseReset),
	]);
}
